import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AboutSection() {
    Section({
        id("About")
        style {
            padding(48.px)
            backgroundColor(Color("#f5f5f5"))
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Row)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.SpaceBetween)
            fontFamily("Roboto, sans-serif")
            marginTop(100.px) // Ensure this matches the height of your fixed header
            property("border-radius", "8px") // Rounded corners for the section
            property("box-shadow", "0 2px 10px rgba(0, 0, 0, 0.1)") // Soft shadow
        }
    }) {
        // Left side: Text content
        Div({
            style {
                maxWidth(600.px)
                paddingRight(32.px)
                fontFamily("Roboto, sans-serif")
            }
        }) {
            H2({
                style {
                    color(Color("#333"))
                    fontSize(32.px)
                    marginBottom(16.px) // Space between title and paragraph
                }
            }) { Text("About Me") }

            P({
                style {
                    color(Color("#555"))
                    fontSize(18.px)
                    lineHeight("1.5")
                }
            }) {
                Text(
                    "Hello! I'm an Android developer with experience in Kotlin, Java, Jetpack Compose, " +
                            "and Android SDK. I build efficient, scalable apps with a focus on UI and UX."
                )
            }
        }

        // Right side: Profile image
        Div({
            style {
                paddingLeft(32.px)
                textAlign("center") // Center the image
            }
        }) {
            Img(src = "https://s3.amazonaws.com/mahmouderaqi.com/1702317094134.jpeg", alt = "Profile Picture") {
                style {
                    width(200.px)
                    height(200.px)
                    borderRadius(50.percent)
                    property("object-fit", "cover")
                    property("box-shadow", "0px 4px 10px rgba(0, 0, 0, 0.1)")
                    property("transition", "transform 0.3s") // Smooth hover effect
                }
                // Add hover effect
                onMouseEnter {
                    style {
                        property("transform", "scale(1.05)") // Slight zoom on hover
                    }
                }
                onMouseLeave {
                    style {
                        property("transform", "scale(1)") // Reset scale
                    }
                }
            }
        }
    }
}
